module.exports = __webpack_public_path__ + "static/media/img-topics-sample07.f8f48d46.jpg";